import dynamic from "next/dynamic";
import VideoBackgroundAssetConfig from "./video-background-asset-config";
import VideoBackgroundAssetAdvancedConfig from "./video-background-asset-advanced-config";
const VideoBackgroundAssetComponent = dynamic(()=>import("./video-background-asset-component"));
export default {
    VideoBackgroundAssetComponent,
    VideoBackgroundAssetConfig,
    VideoBackgroundAssetAdvancedConfig
};
